export default __webpack_public_path__ + "static/media/Pin_KeyReplace.2ee505fb.svg";